type CsvBadgeIconProps = {
  className?: string;
  width?: number | string;
  height?: number | string;
};

const CsvBadgeIcon = ({
  className,
  width = 37,
  height = 24,
}: CsvBadgeIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <rect width="37" height="24" rx="4" fill="#1DB3A4" />
      <path
        d="M12.6914 10.2812C12.4805 9.19141 11.5781 8.58203 10.5 8.58203C9.03516 8.58203 7.94531 9.70703 7.94531 11.7578C7.94531 13.8203 9.04688 14.9336 10.5 14.9336C11.5664 14.9336 12.4688 14.3359 12.6914 13.2578L13.9922 13.2695C13.7227 14.9453 12.3516 16.1172 10.4883 16.1172C8.27344 16.1172 6.66797 14.4648 6.66797 11.7578C6.66797 9.03906 8.28516 7.39844 10.4883 7.39844C12.2812 7.39844 13.6992 8.45312 13.9922 10.2812H12.6914ZM20.5039 9.75391C20.4219 8.96875 19.7305 8.51172 18.7578 8.51172C17.7148 8.51172 17.0586 9.03906 17.0586 9.76562C17.0586 10.5742 17.9375 10.8789 18.6055 11.043L19.4258 11.2656C20.5156 11.5234 21.8633 12.1211 21.875 13.6562C21.8633 15.0859 20.7266 16.1406 18.7227 16.1406C16.8242 16.1406 15.6289 15.1914 15.5469 13.6445H16.8359C16.918 14.5703 17.7266 15.0156 18.7227 15.0156C19.8008 15.0156 20.5859 14.4648 20.5977 13.6328C20.5859 12.8945 19.8945 12.5898 18.9922 12.3555L17.9844 12.0859C16.625 11.7109 15.7695 11.0195 15.7695 9.83594C15.7695 8.37109 17.082 7.39844 18.793 7.39844C20.5156 7.39844 21.7227 8.38281 21.7578 9.75391H20.5039ZM24.5078 7.51562L26.8633 14.418H26.957L29.3125 7.51562H30.707L27.6484 16H26.1602L23.1133 7.51562H24.5078Z"
        fill="white"
      />
    </svg>
  );
};

export default CsvBadgeIcon;
